import React, { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { Amplify } from 'aws-amplify';
import { Hub } from 'aws-amplify/utils';
import HomePage from './components/HomePage';
import AdminPage from './pages/AdminPage';
import awsConfig from './aws-config';
import './App.css';
import './overflow-fix.css';

// Configure AWS Amplify
Amplify.configure(awsConfig);
console.log('✅ Amplify configured with Cognito authentication');

function App() {
  useEffect(() => {
    console.log('🚀 RSS Aggregator App initialized with Cognito authentication');

    // Listen for authentication events using Amplify v6 syntax
    const hubListener = Hub.listen('auth', (data) => {
      const { payload } = data;
      console.log('🔔 Auth event:', payload.event, payload);
      
      switch (payload.event) {
        case 'signInWithRedirect':
          console.log('✅ Sign in with redirect successful');
          break;
        case 'signInWithRedirect_failure':
          console.error('❌ Sign in with redirect failed:', payload.data);
          break;
        case 'customOAuthState':
          console.log('🔄 Custom OAuth state:', payload.data);
          break;
        case 'signedIn':
          console.log('✅ User signed in successfully');
          break;
        case 'signedOut':
          console.log('👋 User signed out');
          break;
        default:
          console.log('🔔 Other auth event:', payload.event);
      }
    });

    // Cleanup listener on unmount
    return () => {
      if (hubListener && typeof hubListener === 'function') {
        hubListener();
      }
    };
  }, []);

  return (
    <Router>
      <div className="app">
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/admin" element={<AdminPage />} />
        </Routes>
      </div>
    </Router>
  );
}

export default App;
